import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";

const GiftCardsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang, setSupportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("gift_cards.details"),
            data: {
              images: details?.image && [{ id: 0, img: details?.image }],
              list: detailsData(t, { data: details }),
            },
          }}
          table={{
            list: data,
            listTitle: t("gift_cards.list_title"),
            createBtnTitle: can_create && t("gift_cards.new_card"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "image",
                Header: t("gift_cards.card_image"),
              },
              {
                accessor: "localized_data.en.name",
                Header: "Card Name(EN)",
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: "Card Name(AR)",
                sort: true,
              },
              { accessor: "price", Header: t("gift_cards.price"), sort: true },
              {
                accessor: "price_after_discount",
                Header: t("gift_cards.price_after_discount"),
                sort: true,
              },
              { accessor: "status", Header: t("products.col_status"), sort: true },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t("gift_cards.search_by_tag"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "organization-table system-configurations-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            className: "main-table",
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(supportedLang, t),
            validationSchema: validationSchema(t),
            deleteFun: deleteFun,
            title: id ? t("gift_cards.edit_gift_card") : t("gift_cards.new_gift_card"),
            submitTitle: id ? t("admin_users.btn_update") : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default GiftCardsTemplate;
